module.exports = __webpack_public_path__ + "static/media/nuvemshopCard.25741040.png";